var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEducational = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h14v14H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m8.257 6.929 2.181-.786.057.632a3.38 3.38 0 0 0-2.948 2.633 8.4 8.4 0 0 1-3.518-.432c-.637-.231-1.057-1.139-.976-2.102l.067-.73 2.183.785a4.42 4.42 0 0 0 2.954 0m4.471-3.943a.66.66 0 0 1 .42.366.67.67 0 0 1 0 .556.65.65 0 0 1-.42.379L7.931 6.022c-.744.27-1.56.27-2.303 0L3.175 5.14s1.423-.773 2.52-1.396L2.58 4.924a1 1 0 0 0-.46.351 1 1 0 0 0-.177.556v3.47q.163.039.285.162a.6.6 0 0 1 .163.284l.203.841a.96.96 0 0 1-.19.867 1.01 1.01 0 0 1-.786.393 1 1 0 0 1-.785-.393.99.99 0 0 1-.177-.867l.203-.841a.6.6 0 0 1 .163-.284.6.6 0 0 1 .284-.163V5.82c0-.448.19-.868.515-1.18l-.988-.352a.66.66 0 0 1-.42-.367.65.65 0 0 1 0-.554.7.7 0 0 1 .42-.367l4.796-1.735c.744-.27 1.559-.27 2.303 0zm-4.7 7.142a2.81 2.81 0 1 1 5.621 0 2.81 2.81 0 0 1-5.62 0m1.092.015 1.444 1.47c.247-.638 1.035-1.88 1.996-2.763l-.088-.207a9.2 9.2 0 0 0-2.146 1.858l-.838-.656z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export { SvgEducational as ReactComponent };
export default __webpack_public_path__ + "static/media/Educational.82d0937ff69b861929de98bee286ffcd.svg";